import React, { useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Split from "react-split";
import AgTable from "../../Analyze/AnalyzeTransactionsTable/AgTable";
import { useTransactionsAutomaticMode } from "../../Analyze/AnalyzeTransactionsTable/hooks";
import { useDispatch, useSelector } from "react-redux";
import { ReduxState } from "../../../../redux";
import { fetchTls } from "../../../../redux/reducers/TransactionManager";
import PDFViewer from "../../PdfViewer";
import useBankStatementPDF from "./useBankStatementPDF";
import { getDocumentName } from "../../Analyze/AnalyzeTransactionsTable/utils";

export const AutomaticModeTable: React.FC = () => {
  const dispatch = useDispatch();
  const [selectedDocumentId, setSelectedDocumentId] =
    React.useState<string>("");

  const { tls } = useSelector((state: ReduxState) => state.TransactionManager);
  const { documents } = tls;
  const { job } = useSelector((state: ReduxState) => state.JobData);

  React.useEffect(() => {
    dispatch(fetchTls(true));
  }, []);

  // Add effect to select first document when documents are loaded
  React.useEffect(() => {
    if (documents?.length > 0 && !selectedDocumentId) {
      setSelectedDocumentId(documents[0].id as any);
    }
  }, [documents]);

  const transactions = useTransactionsAutomaticMode(
    (selectedDocumentId || "").toString()
  );

  // Filter transactions by selected document

  const { pdfURL } = useBankStatementPDF({
    selectedDocumentId,
  });

  let cols: any[] = [];
  let colNames: string[] = [];

  for (const t of transactions) {
    const keys = Object.keys(t);
    if (keys.length > colNames.length) {
      colNames = keys;
    }
    cols = colNames.map((name) => ({
      field: name,
      headerName: `Col ${name}`,
    }));
  }

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <Form.Group className="w-25">
            <strong>
              <Form.Label>Document</Form.Label>
            </strong>
            <Form.Control
              as="select"
              value={selectedDocumentId}
              onChange={(e) => setSelectedDocumentId(e.target.value)}
            >
              {documents?.map((doc) => (
                <option key={doc.id} value={doc.id}>
                  {getDocumentName(documents, doc.id)}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
      <Split
        sizes={[40, 60]}
        direction="horizontal"
        style={{ display: "flex", height: "90vh" }}
      >
        {
          <div style={{ width: "100%" }} className="mr-2">
            <PDFViewer
              key={`${selectedDocumentId}-${job?.id}`}
              url={pdfURL}
              height={"90vh"}
            />
          </div>
        }
        <div style={{ width: "100%" }} className="ml-4">
          <AgTable
            columnDefs={cols}
            hasExport={false}
            height={"80vh"}
            width={"100%"}
            rowData={transactions}
            pagination={true}
            paginationAutoPageSize={true}
          />
        </div>
      </Split>
    </div>
  );
};

export default AutomaticModeTable;
